export const style = {
  wrapper: {
    padding: `0 25px`
  },
  box: {
    padding: `20px`,
    border: `1px solid #ddd`,
    borderRadius: `3px`
  },
  row: {
    padding: 0,
    ':not(:last-of-type)': {
      borderBottom: `1px solid #ddd`
    }
  },
  label: {
    fontSize: `14px`,
    paddingTop: `6px`
  },
  value: {
    color: `#A94545`,
    fontSize: `16px`,
    fontWeight: 400,
    lineHeight: `35px`,
    alignText: `right`
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/Statistics/style/daily.js